export default __webpack_public_path__ + "static/media/1878.58ee28f9.png";